AuthRoute = require 'mixins/authenticated-route'

App.SettingsBillingTariffsRoute = Em.Route.extend AuthRoute,
  actions:
    didTransition: ->
      paywall_accepted = @controllerFor('settings.billing').get('billingInfo.paywall_accepted')

      if paywall_accepted
        currentTariff = @controllerFor('settings.billing').get('currentTariff.service')
        @controllerFor('settings.billing.tariffs').set('selectedTariff', currentTariff)